/*
 * The recruiter app's routing table — one file per domain, concatenated here.
 *
 * FE-02: every screen is a lazy-loaded route gated on an entitlement key, and a route without an
 * entitlement declaration fails the build. `gates/route-manifest-lint.mjs` reads the files under
 * `./routes/` and checks each entry; it also checks that every one of them is imported below,
 * because a domain file that existed and was never concatenated would be a screen nobody could
 * reach and every other check in that gate would pass on it.
 *
 * **The order of this array is behaviour, not presentation.** TanStack Router matches in order, so
 * a static path must precede the `$param` route that would otherwise swallow it — `candidate-upload`
 * before `candidate-detail`, `interview-client-view` before any future `/interviews/$id`. Those
 * pairs sit inside a single file each, precisely so that concatenation cannot break them; what this
 * file preserves is the order *between* domains, which is why it is a written-out list rather than
 * a directory scan.
 *
 * The import surface is unchanged: `ROUTES` and `RouteManifestEntry` are still what this module
 * exports, and everything that imported them from here still does.
 */

export type { RouteManifestEntry } from './route-manifest.js';

import type { RouteManifestEntry } from './route-manifest.js';
import { AUTH_ROUTES } from './routes/auth.js';
import { CLIENT_ROUTES } from './routes/clients.js';
import { PIPELINE_ROUTES } from './routes/pipeline.js';
import { CANDIDATE_ROUTES } from './routes/candidates.js';
import { ACCESS_ROUTES } from './routes/access.js';
import { INSIGHT_ROUTES } from './routes/insight.js';
import { INTERVIEW_ROUTES } from './routes/interviews.js';
import { SEARCH_ROUTES } from './routes/search.js';
import { TEAM_ROUTES } from './routes/teams.js';
import { SETTINGS_ROUTES } from './routes/settings.js';

export const ROUTES: readonly RouteManifestEntry[] = [
  ...AUTH_ROUTES,
  ...CLIENT_ROUTES,
  ...PIPELINE_ROUTES,
  ...CANDIDATE_ROUTES,
  ...ACCESS_ROUTES,
  ...INSIGHT_ROUTES,
  ...INTERVIEW_ROUTES,
  ...SEARCH_ROUTES,
  ...TEAM_ROUTES,
  ...SETTINGS_ROUTES,
];
